import { Box, Button, Stack, TextField } from "@mui/material";
import { useState } from "react";

import "./LiveChatModule.css";

interface propsType {
  nickname: string;
  setNicknameChange: any;
  changeAdminNickname: any;
}

const NicknameUpdate = ({
  nickname,
  setNicknameChange,
  changeAdminNickname,
}: propsType) => {
  const [currentNickname, setCurrentNickname] = useState(nickname);

  return (
    <Box
      id="update-nickname-box"
      sx={{ display: "flex", flexGrow: 1, alignItems: "center" }}
    >
      <TextField
        id="update-nickname"
        className=""
        inputProps={{
          maxLength: 20,
          enterKeyHint: "Send",
          style: { overflowY: "hidden", padding: "0px 14px" },
        }}
        type="search"
        autoComplete="off"
        sx={{
          width: "100%",
          color: "black",
          "&::placeholder": { color: "gray" },
        }}
        placeholder="사용할 닉네임을 입력하세요(최대 20자)"
        value={currentNickname}
        onChange={(e) => setCurrentNickname(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setNicknameChange(false);
            changeAdminNickname(currentNickname);
          }
        }}
      />
      <Stack direction="row" spacing={1}>
        <Button
          variant="contained"
          size="small"
          sx={{ fontSize: "12px", lineHeight: "18px", minWidth: "50px" }}
          onClick={() => {
            setNicknameChange(false);
            changeAdminNickname(currentNickname);
          }}
        >
          변경
        </Button>
        {nickname !== "" && nickname !== undefined && (
          <Button
            variant="outlined"
            size="small"
            sx={{ fontSize: "12px", lineHeight: "18px", minWidth: "50px" }}
            onClick={() => setNicknameChange(false)}
          >
            취소
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default NicknameUpdate;
